import { ItemType } from '../../common/misc/item-type.enum';
import { ContentTaskType } from './content-task-type.enum';
import { ContentTaskStatus } from './content-task-status.enum';
import { ContentTaskPriority } from './content-task-priority.enum';
var ContentTaskBuilder = /** @class */ (function () {
    function ContentTaskBuilder() {
        this.contentTask = {
            id: 'c0cc0c0b-c0c0-c0c0-c0c0-c0cc0cc0cc0c',
            itemId: 'b0bb0b0b-b0b0-b0b0-b0b0-b0bb0bb0bb0b',
            itemType: ItemType.ARTICLE,
            locale: 'en',
            description: 'You do it!',
            status: ContentTaskStatus.OPEN,
            priority: ContentTaskPriority.MEDIUM,
            type: ContentTaskType.UPDATE,
            creationDate: Date.now(),
            lastUpdateDate: Date.now() + 20000
        };
    }
    ContentTaskBuilder.prototype.withId = function (id) {
        this.contentTask.id = id;
        return this;
    };
    ContentTaskBuilder.prototype.withItemId = function (itemId) {
        this.contentTask.itemId = itemId;
        return this;
    };
    ContentTaskBuilder.prototype.withNotes = function (notes) {
        this.contentTask.notes = notes;
        return this;
    };
    ContentTaskBuilder.prototype.withItemType = function (itemType) {
        this.contentTask.itemType = itemType;
        return this;
    };
    ContentTaskBuilder.prototype.withLang = function (lang) {
        this.contentTask.locale = lang;
        return this;
    };
    ContentTaskBuilder.prototype.withDescription = function (description) {
        this.contentTask.description = description;
        return this;
    };
    ContentTaskBuilder.prototype.withType = function (type) {
        this.contentTask.type = type;
        return this;
    };
    ContentTaskBuilder.prototype.withStatus = function (status) {
        this.contentTask.status = status;
        return this;
    };
    ContentTaskBuilder.prototype.withPriority = function (priority) {
        this.contentTask.priority = priority;
        return this;
    };
    ContentTaskBuilder.prototype.withCreationDate = function (creationDate) {
        this.contentTask.creationDate = creationDate;
        return this;
    };
    ContentTaskBuilder.prototype.withLastUpdateDate = function (lastUpdateDate) {
        this.contentTask.lastUpdateDate = lastUpdateDate;
        return this;
    };
    ContentTaskBuilder.prototype.withCompletionDate = function (completionDate) {
        this.contentTask.completionDate = completionDate;
        return this;
    };
    ContentTaskBuilder.prototype.withAssignedByUser = function (assignedUser) {
        this.contentTask.assignedUser = assignedUser;
        return this;
    };
    ContentTaskBuilder.prototype.withCompletedByUser = function (completedByUser) {
        this.contentTask.completedByUser = completedByUser;
        return this;
    };
    ContentTaskBuilder.prototype.withCreatedByUser = function (createdByUser) {
        this.contentTask.createdByUser = createdByUser;
        return this;
    };
    ContentTaskBuilder.prototype.build = function () {
        return this.contentTask;
    };
    return ContentTaskBuilder;
}());
export { ContentTaskBuilder };
//# sourceMappingURL=content-task.builder.js.map